import { Component, OnInit } from '@angular/core';
import { OverlayService } from 'src/app/services/UI/overlay.service';
import { PopupBaseComponent } from 'src/app/components/common/popup-base/popup-base.component';
import { PopupResponseEvents, MultimediaPopupOpenMode, PopupOpenMode, ResourceType } from 'src/app/common/enums/enums';
import { PlacePopupResponse, PopupResponse } from 'src/app/common/models/PopupResponse';
import { PlacePopupInputInfo, SunChartOptionPopupInputInfo } from 'src/app/common/models/PopupInputInfo';
import { PlaceAPIService } from 'src/app/services/API/place-api.service';
import { PlaceInfo } from 'src/app/common/models/PlaceInfo';
import { GuidGenerator } from 'src/app/common/helpers/guid-generator';
import { LoadingService } from 'src/app/services/UI/loading.service';
import { ParentMessageType } from 'src/app/common/models/ParentMessage';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { CustomError } from 'src/app/common/helpers/custom-error';
import { ResponseModel } from 'src/app/common/models/ResponseModel';
import { ConfirmationInputInfo } from 'src/app/common/models/ConfirmationInputInfo';
import { ConfirmationContent } from 'src/app/common/models/ConfirmationContent';
import { ConfirmationDialogService } from 'src/app/services/UI/confirmation-dialog.service';
import { first } from 'rxjs/operators';
import { PlaceReferences } from 'src/app/common/models/MediaReferences';
import { PlacemanagementService } from '../services/placemanagement.service';
import { MultiMediaFilter, PlaceFilter } from 'src/app/common/helpers/filter';
import { PlaceViewModel } from 'src/app/common/models/PlaceViewModel';
import { observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';

@Component({
    selector: 'app-mainplace',
    templateUrl: './mainplace.component.html',
    styleUrls: ['./mainplace.component.scss'],
    standalone: false
})
export class MainplaceComponent extends PopupBaseComponent implements OnInit {

  //Variable Declarations
  id: number;
  rawData: any;
  isSaveEnable: boolean;
  addTitle: string;
  selectedPlaces = [0];
  list: any;
  selectedPlaceCaption: string = '';
  placeDeselected: boolean = false;
  isFullScreenPopUp: boolean;
  imageError: boolean = false;
  deletePlaceId: number = 0;
  isPlaceEditorOpen = false
  filterTypes = [];

  //Object Declaration
  selectedItem: PlaceViewModel = new PlaceViewModel();

  //Subscription Declarations
  placeManagementSubscription: any;
  confirmationServiceSubscription: any;

  resourceType: string = ResourceType[ResourceType.Place];


  constructor(
    private placemanagmentservice: PlacemanagementService,
    private parentCommunicatorService: ParentCommunicatorService,
    overlayService: OverlayService,
    private apiPlaceService: PlaceAPIService,
    private confirmationDialogService: ConfirmationDialogService,
    private translateService: TranslateService,
    private loadingService: LoadingService,
    private translateHandler: TranslateHandler) {
    super(placemanagmentservice, overlayService)
  }

  ngOnInit(): void {
    this.show();
    this.display();
    this.filterTypes = PlaceFilter.getFilters();
  }

  ngOnDestroy() {
    this.placeManagementSubscription.unsubscribe();
    this.confirmationServiceSubscription.unsubscribe();
  }

  //Display place list popup
  display() {
    this.isSaveEnable = false;

    this.placeManagementSubscription = this.placemanagmentservice.onVisibilityChanged().
      subscribe((placeInputResponse: PlacePopupInputInfo) => {
        if (placeInputResponse.visibility) {
          this.popupWidth = placeInputResponse.popWidth;
          this.addTitle = placeInputResponse.Title;
          this.selectedPlaces = placeInputResponse.SelectedPlaceIds;

          if (placeInputResponse.Mode === PopupOpenMode.List) {
            //this.isPlaceEditorOpen = false;
            this.getPlaces();
          }
          else // Show place edit view
            this.isPlaceEditorOpen = true;
        }
      })
  }

  getPlaces() {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    let size = 0;
    let page = 0
    //this.list = [];
    this.deletePlaceId = 0;
    this.apiPlaceService.getPlaceList(size, page).subscribe((data: any) => {
      console.log(data)
      this.list = data.data
    }).add(() => {
      this.loadingService.hide(processId);
    })
  }

  selected() {
    this.isSaveEnable = false;
    let PlacePopupInfo = new PlacePopupResponse();
    let placeData = new PlaceInfo();
    placeData.id = this.id;
    placeData.fullAddress = this.rawData;
    PlacePopupInfo.Info = placeData;
    this.placemanagmentservice.setSelection(PlacePopupInfo);
    this.placemanagmentservice.changeVisibility(false, null);
  }

  selectedPlace(selectedMediaInfo: any) {
    this.isSaveEnable = true;

    if (selectedMediaInfo.isDeselect) {
      this.id = 0
      this.rawData = null

    } else {
      this.id = selectedMediaInfo.item.id;
      this.rawData = selectedMediaInfo.item.fullAddress;
    }

    let item = selectedMediaInfo.item;
    // this.selectedMultimedia = item;
    this.placeDeselected = selectedMediaInfo.isDeselect;
    this.imageError = selectedMediaInfo.isErrorItem;
    this.isSaveEnable = selectedMediaInfo.isSaveEnable;

    if (item) {
      if (item.caption && !this.placeDeselected) {
        this.selectedPlaceCaption = item.caption;
      }
      else if (item.fileName && !this.placeDeselected) {
        this.selectedPlaceCaption = item.fileName;
      }
      else {
        this.selectedPlaceCaption = '';
      }
    } else {
      this.selectedPlaceCaption = '';
    }
  }

  //Show delete confirmation popup
  showDeleteConfirmation(item, references) {
    let confirmationDialogHeader = 'lbl_delete_confiramation_header';
    let confirmationDialogfooter = 'cnf_delete_confirmation';
    let confirmationDialogBody = this.prepareMiddleMessage(references);
    let popupInputData = new ConfirmationInputInfo();
    popupInputData.Visibility = true;
    let confirmationContent = new ConfirmationContent();
    confirmationContent.ConfirmationDialogHeader = confirmationDialogHeader;
    confirmationContent.ConfirmationDialogBody = confirmationDialogBody;
    confirmationContent.ConfirmationDialogFooter = confirmationDialogfooter;
    popupInputData.ConfirmationContent = confirmationContent;
    this.confirmationServiceSubscription = this.confirmationDialogService.OpenPopup(popupInputData)
      .pipe(first())
      .subscribe((response: boolean) => {
        if (response) {
          this.deletePlaceById(item.id);
        } else {
          this.deletePlaceId = 0;
        }
      }, (err) => {
        throw new CustomError("MainPlaceComponent => showDeleteConfirmation() : " + err, 911, false);
      }
      );
  }

  //Delete selected place by Id
  deletePlaceById(placeId) {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.apiPlaceService.deletePlaceData(placeId)
      .pipe(first())
      .subscribe((response: any) => {
        this.loadingService.hide(processId);
        let deleteObj = this.list.find(s => s.id == placeId);
        this.list.splice(this.list.indexOf(deleteObj), 1);
        this.deletePlaceId = placeId;
      },
        (err) => {
          this.loadingService.hide(processId);
          throw new CustomError("MainPlaceComponent => deletePlaceById() : " + err, 911, false);
        });
  }

  deletePlace(item) {
    //this.showDeleteConfirmation(item, null);
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.apiPlaceService.getPlaceReferences(item.id).subscribe((response: ResponseModel<PlaceReferences>) => {
      let references = response.data;
      this.loadingService.hide(processId);
      this.showDeleteConfirmation(item, references);
    },
      (err) => {
        this.loadingService.hide(processId);
        throw new CustomError("MainPlaceComponent => deletePlace() : " + err, 911, false);
      });
  }

  //Prepare custom message for delete confirmation related to place reference
  prepareMiddleMessage(references: PlaceReferences) {
    let message = this.translateService.instant('cnf_delete_place_confirmation_message') + ' ';
    if (references.total > 0) {
      let includeComma: boolean = false;

      if (references.events.length > 0) {
        message += this.translateHandler.translate('lnk_events', [references.events.length.toString()])
        includeComma = true;
      }
      if (references.sources.length > 0) {
        message += (includeComma ? ', ' : '') + this.translateHandler.translate('lnk_sources', [references.sources.length.toString()])
        includeComma = true;
      }
    }
    return message;
  }

  cancel() {
    this.isSaveEnable = false;
    if (this.isPlaceEditorOpen) {
      this.isPlaceEditorOpen = false
    } else {
      let popupResponse = new PopupResponse();
      popupResponse.Status = PopupResponseEvents.Cancelled;
      this.placemanagmentservice.setSelection(popupResponse);
      this.placemanagmentservice.changeVisibility(false, null);
    }
  }

  //Set the place to the event(ex:Birth event)
  setPlaceToEvent(updated) {
    this.id = updated.id
    this.rawData = updated.fullAddress;
    this.isPlaceEditorOpen = false
    this.selected();
  }

  editPlace(editMediaInfo: any) {
    this.selectedItem = new PlaceViewModel();
    Object.assign(this.selectedItem, editMediaInfo);
    this.isPlaceEditorOpen = true;
  }

  detectPlaceChange(item) {
    this.getPlaces();
  }

  // open place list tab
  openPlaceListTab() {
    this.isPlaceEditorOpen = !this.isPlaceEditorOpen;
  }

  // open place editor tab
  openPlaceEditorTab() {
    this.selectedItem = new PlaceViewModel()
    this.isPlaceEditorOpen = true
  }

  // close place editor and redirect to the place list
  closePopup() {
    this.openPlaceListTab()
  }


  reload(reload) {
  }

  // To reuse in future
  showNotImplemented() {
    this.parentCommunicatorService.send(
      ParentMessageType.ShowInformation,
      "not_implemented"
    );
  }

}
